import type { YarnProductCard as YarnProductCardType } from "@/types/product";

import PC from "../../ProductCardTemplate";
import config from "../../config";

import {
  Colors,
  WeightAndLength,
  YarnWidget,
} from "../../parts/YarnWidget/YarnWidget";

const { Card, Gallery, Tags, Content, Description, Price, Name } = PC;

const YarnProductCard = ({ data }: { data: YarnProductCardType }) => {
  if (!data) return null;
  const { core, gallery, description } = data;

  const { yarnLengthAndWeight, name, yarnOptionLength } = description || {};
  return (
    <Card name={core?.name ?? ""} slug={config.slugs.yarn + core?.slug}>
      <Gallery
        url={gallery?.image?.uri ?? ""}
        alt={gallery?.image?.alt ?? ""}
        secondImage={gallery?.secondImage}
      >
        <Tags activeTag={gallery?.activeTag} />
      </Gallery>
      <Content>
        <Description>
          {name && <Name>{name}</Name>}

          <YarnWidget>
            <WeightAndLength>{yarnLengthAndWeight}</WeightAndLength>
            <Colors
              total={yarnOptionLength ?? 0}
              swatchUrl={gallery?.secondImage?.uri ?? gallery?.image?.uri}
            />
          </YarnWidget>

          <span>{description?.yarnMaterials}</span>
        </Description>
        <Price
          price={description?.price}
          priceBeforeDiscount={description?.priceBeforeDiscount}
        />
      </Content>
    </Card>
  );
};

export default YarnProductCard;
